// One arbitrary form ID (setup on Hubspot) used in development and staging not to pollute production forms
export const DEV_HUBSPOT_FORM_ID = '7f73de26-042b-479f-98c3-8c1fd3c1f103';
